module.exports = __webpack_public_path__ + "static/stacked-shapes-5ef31eacc6b7b48875c19c19d8034d41.png";